import React, {FunctionComponent, useEffect} from "react";
import {Tabs} from 'antd';
import "./index.css";
import {useDispatch} from "react-redux";
import {AppSideBarPageActions, SideBarOptions} from "../../parts/AppSideBar/model";
import {Redirect, Route, Switch, useHistory, useRouteMatch} from "react-router-dom";
import {Routes} from "../../common/Routes";
import PolicyList from "./policyList/policyList";
import {allPoliciesTab} from "./policyList/model";
import {PageTitle} from "../../components/page-title";
import {CreatePolicyActions} from "./managePolicy/model";
import AuthZButton from "src/components/AuthzButton";


export const PolicyDetail: FunctionComponent = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(AppSideBarPageActions.updateSelectedSideBar(SideBarOptions.POLICIES));
  }, []);

  const createPolicy = () => {
    history.push(
      `${Routes.Policies.createPath}`,
    );
    dispatch(CreatePolicyActions.resetCreatePolicy());
  }
  return (
    <div className={"policyContainer"}>
      <Switch>
        <Route
          exact={true}
          path={match.path}
        >
          <PageTitle title="Policies"/>
          <Tabs
            className={"tabContainer"}
            type="editable-card"
            hideAdd
          >
            <Tabs.TabPane
              tab={allPoliciesTab.name}
              key={allPoliciesTab.id}
              closable={false}
            >
              <div className={"createPolicyButton"}>
                {/*@ts-ignore*/}
                <AuthZButton
                  authZButtonType="primary"
                  onClick={createPolicy}
                >
                  Create Policy
                </AuthZButton>
              </div>
              <PolicyList/>
            </Tabs.TabPane>
          </Tabs>
        </Route>
        <Route>
          <Redirect to={Routes.NotFound.path}/>
        </Route>
      </Switch>
    </div>
  );
};

